import { initGlobalState } from "qiankun";
import Vue from "vue";
import http from "@/api/apiList";
import store from "@/store/index";
// import ase from "@/utils/aes.js";
import Cookies from "js-cookies";

let removeCookies = window.HS_CONFIG.removeCookies;

let initState = Vue.observable({
  //登出标志
  logout: false,
  //accessToken
  // accessToken: localStorage.getItem("accessToken")
  //   ? ase.decrypt(localStorage.getItem("accessToken"))
  //   : "",
  languageUpdate: false,

  accessToken: localStorage.getItem("accessToken"),
  //commonData修改
  dataUpdate: false,
  // 当前用户信息
  currentUser: "",
  // 当前用户权限树
  permissionTree: "",
  // 获取token报错
  getTokenError: false,
  //当前语言    如果没有 默认选择中文
  currentLanguage:
    localStorage.getItem("localeLanguage") ?? window.HS_CONFIG.DEFAULT_LANGUAGE,
  //当前客户
  currentCustomer: localStorage.getItem("as-currentCustomer") ?? "",
  //当前门店
  currentStore: localStorage.getItem("as-currentStore") ?? "",
  //控制菜单  隐藏显示
  showMenu: true,
  // 公共客户门店数据
  commonData: {},
  // 当前应用名称
  currentAppName: localStorage.getItem("currentAppName") ?? "",
});

const actions = initGlobalState(initState);
actions.getGlobalState = (key) => {
  return key ? initState[key] : initState;
};

actions.onGlobalStateChange((state, prev) => {
  // state: 变更后的状态; prev 变更前的状态
  // 当前退出状态和要改变的状态都为true的时候，不做任何操作，等待之前的退出任务完成
  if (prev.logout == true && state.logout == true) {
    console.log("之前有退出任务,不做任何处理");
    return;
  }

  for (const key in state) {
    initState[key] = state[key];
  }

  console.log("变更后门店", state.currentStore);
  localStorage.setItem("as-currentCustomer", state.currentCustomer);
  localStorage.setItem("as-currentStore", state.currentStore);
  localStorage.setItem("currentAppName", state.currentAppName);
  localStorage.setItem("localeLanguage", state.currentLanguage);
  // app变化监听
  if (!state.currentAppName == prev.currentAppName) {
    console.log("当前应用变化");
  }

  if (state.languageUpdate == true) {
    store.commit("config/updateLanguageList");
    store.commit("config/updateLanguageData");
    window.setTimeout(() => {
      actions.setGlobalState({
        languageUpdate: false,
      });
    }, 0);
  }
  //退出
  if (initState.logout == true) {
    // 需要调用logout接口
    // window.setTimeout(() => {
    console.log("base   监听到logout为true");
    http.logout().then((res) => {
      if (res.resultCode == 1001) {
        console.log("退出");
        // cookies 删除
        actions.setGlobalState({
          //登出标志
          logout: false,
          accessToken: "",
          //commonData修改
          dataUpdate: false,
          // 当前用户信息
          currentUser: "",
          // 当前用户权限树
          permissionTree: "",
          // 获取token报错
          getTokenError: false,
          //当前客户
          currentCustomer: "",
          //当前门店
          currentStore: "",
          //控制菜单  隐藏显示
          showMenu: true,
          // 公共客户门店数据
          commonData: {},
          currentAppName: "",
        });

        localStorage.removeItem("accessToken");
        localStorage.removeItem("username");
        localStorage.removeItem("as-currentCustomer");
        localStorage.removeItem("as-currentStore");
        localStorage.removeItem("currentAppName");
        localStorage.removeItem("as-languageList");
        localStorage.removeItem("as-languageData");
        sessionStorage.clear();

        // 退出时删除 cookies
        removeCookies.forEach((item) => {
          Cookies.removeItem(item);
        });

        // // 重定向至登录页面
        let currentUrl = window.location.href;
        let position = currentUrl.indexOf("/#");
        let loginUrl = currentUrl.substring(0, position);
        window.location.href = loginUrl;
      }
    });
    // }, 0);
  }

  if (initState.dataUpdate == true) {
    new Promise((resolve, reject) => {
      http
        .getWorkBench()
        .then((res) => {
          if (res.resultCode == 1001) {
            actions.setGlobalState({
              commonData: {
                customer: res.data.customers, // 该用户下所有客户
                username: res.data.username,
                userId: res.data.userId,
                data: res.data.data,
              },
              currentUser: res.data.user,
              permissionTree: res.data.permissionTree,
            });
            resolve(res);
          }
        })
        .catch((err) => reject(err));
    });
    //归位
    window.setTimeout(() => {
      actions.setGlobalState({
        dataUpdate: false,
      });
    }, 0);
  }
});

export default actions;
